import { collection, doc, getDoc, getDocs, query, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";



export const uploadDocuments = async (data) => {
  const uploadDate = new Date();
  const vaultRef = doc(collection(db, `users/${auth.currentUser.uid}/vault/userVault/${data?.documentType}`));
  const vaultRef2 = doc(db, `users/${auth.currentUser.uid}/vault`, "totalSize");
  await setDoc(vaultRef, { ...data, uploadDate, id: auth.currentUser.uid });
  await getDoc(vaultRef2);
  const res = await getDoc(vaultRef2);
  if (res.exists()) {
    await setDoc(vaultRef2, { total: res.data().total + data?.fileSize });
  } else {
    await setDoc(vaultRef2, { total: data?.fileSize });
  }
  return "success";
};

export const getFiles = async (documentType) => {
  const vaultRef = query(collection(db, `users/${auth.currentUser.uid}/vault/userVault/${documentType}`));
  const querySnapshot = await getDocs(vaultRef);
  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
};

export const getTotalUsed = async () => {
  const vaultRef = doc(db, `users/${auth.currentUser.uid}/vault`, "totalSize");
  const res = await getDoc(vaultRef);
  if (res.exists()) {
    return res.data().total;
  } else {
    return 0;
  }
};

export const getClaims = async () => {
  const claimsRef = query(collection(db, `users/${auth.currentUser.uid}/claims`));
  const querySnapshot = await getDocs(claimsRef);
  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
};

export const getProjects = async () => {
  const projectsRef = query(collection(db, `users/${auth.currentUser?.uid}/projects`));
  const querySnapshot = await getDocs(projectsRef);
  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
};


